import { useQuery } from "react-query";
import { ApiError, api } from "utils/api";
import { Project } from "../types";
import { reviewablePlaceHolder } from "../types/placeholder";

const placeholderProject = (id: string): Project => ({
  ...reviewablePlaceHolder(id),
  type: "PROJECT",
  team: [],
  mintStatus: [],
  projectLists: [],
});

const getProjectById = (projectId: string) => api(`/projects/${projectId}`);

const useProject = (projectId: string) =>
  useQuery<Project, ApiError>(
    ["PROJECT", projectId],
    () => getProjectById(projectId),
    {
      enabled: !!projectId,
      initialData: placeholderProject(projectId),
    }
  );

export { useProject, placeholderProject, getProjectById };
